module.exports = __webpack_public_path__ + "static/media/marketing2.b79516da.webp";